import { z } from 'zod';

export const contentfulImageReferenceSchema = z.object({
  fields: z.object({
    file: z.object({
      url: z.string(),
    }),
    title: z.string().optional(),
  }),
});
